import { render, staticRenderFns } from "./TabVcDemo.vue?vue&type=template&id=f864e080&scoped=true&"
import script from "./TabVcDemo.vue?vue&type=script&lang=js&"
export * from "./TabVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./TabVcDemo.vue?vue&type=style&index=0&id=f864e080&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f864e080",
  null
  
)

export default component.exports